import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5bb7d93c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=5bb7d93c&prod&lang=less"
import style1 from "./App.vue?vue&type=style&index=1&id=5bb7d93c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7d93c",
  null
  
)

export default component.exports